"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GaiaRequest = void 0;
var Query_1 = require("./request/type/Query");
var Mutation_1 = require("./request/type/Mutation");
var Subscription_1 = require("./request/type/Subscription");
var GaiaRequest = /** @class */ (function () {
    function GaiaRequest() {
    }
    GaiaRequest.query = function (config) {
        var request = new Query_1.Query();
        config(request);
        return request;
    };
    GaiaRequest.mutation = function (config) {
        var request = new Mutation_1.Mutation();
        config(request);
        return request;
    };
    GaiaRequest.subscription = function (config) {
        var request = new Subscription_1.Subscription();
        config(request);
        return request;
    };
    return GaiaRequest;
}());
exports.GaiaRequest = GaiaRequest;
//# sourceMappingURL=GaiaRequest.js.map